import React, { Component } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "../../containers/common/progress_bar";
import { DoubleLeftOutlined, DoubleRightOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./index.css";

const preETaskListItemStyle = {
    margin: '15px',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column'
};

const nameStyle = {
    padding: '10px',
    color: 'white',
    fontWeight: 'bold',
    flexGrow: '1',
    wordWrap: 'break-word',
};

const completedStyle = {
    ...nameStyle,
    backgroundColor: '#7EB941'
};

const incompletedStyle = {
    ...nameStyle,
    backgroundColor: '#AF2025'
};

const completionStyle = {
    padding: '10px',
    textAlign: 'center',
    borderLeft: '1px solid lightgrey',
    borderRight: '1px solid lightgrey',
    fontSize:'15px'
};

const viewTaskStyle = {
    padding: '10px',
    textAlign: 'center',
    border: '1px solid lightgrey'
};

const PreETaskListScrollArea = {
    margin: '20px 0',
    paddingBottom: '10px',
};

class PreETaskListItem extends Component {
    render() {
        const { project, projectId, status, ipsLocations, form, projectAssets = [] } = this.props;
        const isPreJobTasksCompleted = (project.preJobTPercent === 100);
        const isCIPSecCompleted = (project.cipsecurityTPercent === 100);
        const cipSecurityObject = {
            showCIPSecurityTasks: project.showSecurityTasks,
            stationName: project.stationName,
            projectId: project.id,
            status: project.cipsecurityTPercent,
        };
        const preJobObject = {
            showPreJobTasks: project.preJobTPercent !== null,
            stationName: project.stationName,
            projectId: project.id,
            status: project.preJobTPercent,
        };

        // Extract conductor assets from form data
        let conductorObject = null;
        const generalConductorOnlyLocationIds = new Set();

        if (form && form.preFormMappings) {
            const conductorAssets = [];

            form.preFormMappings.forEach(mapping => {
                if (mapping.assets) {
                    const activeAssets = mapping.assets.filter(
                        asset => asset.deleteFlag !== 'Y' && asset.formId === form.id
                    );

                    // Track locations whose active assets are exclusively GeneralConductor
                    if (mapping.ipsLocationId && activeAssets.length > 0) {
                        const hasNonConductorAsset = activeAssets.some(
                            asset => asset.assetGroupName !== 'GeneralConductor'
                        );
                        if (!hasNonConductorAsset) {
                            generalConductorOnlyLocationIds.add(mapping.ipsLocationId);
                        }
                    }

                    const conductors = activeAssets.filter(
                        asset => asset.assetGroupName === 'GeneralConductor'
                    );
                    conductorAssets.push(...conductors);
                }
            });

            if (conductorAssets.length > 0) {
                // Calculate verification percentage based on attestation status
                let verifiedCount = 0;

                conductorAssets.forEach(conductor => {
                    const projectAsset = projectAssets.find(pa => pa.assetId === conductor.assetId);
                    if (projectAsset) {
                        if (projectAsset.attestationStatus) {
                            // Case-insensitive comparison for "Verified" or "VERIFIED"
                            const status = projectAsset.attestationStatus.toUpperCase();
                            if (status === 'VERIFIED') {
                                verifiedCount++;
                            }
                        }
                    } else {
                        console.log(`Conductor ${conductor.assetId} NOT FOUND in project assets`);
                    }
                });

                const verificationPercentage = conductorAssets.length > 0
                    ? Math.round((verifiedCount / conductorAssets.length) * 100)
                    : 0;

                conductorObject = {
                    name: 'Conductors',
                    status: verificationPercentage,
                    conductorAssets: conductorAssets,
                    formId: form.id,
                    isConductorCard: true,
                    verifiedCount: verifiedCount,
                    totalCount: conductorAssets.length
                };
            }
        }

        // Filter out IPS locations where ALL active assets are GeneralConductor —
        // those are already represented by the conductor card
        const filteredIpsLocations = ipsLocations.filter(
            location => !generalConductorOnlyLocationIds.has(location.id)
        );

        let combinedProjectData = project.showSecurityTasks === 1
            ? filteredIpsLocations.concat(cipSecurityObject, preJobObject)
            : filteredIpsLocations.concat(preJobObject);

        // Add conductor card if it exists
        if (conductorObject) {
            combinedProjectData = combinedProjectData.concat(conductorObject);
        }

        const finalSortedArray = combinedProjectData?.sort((a, b) => (a.status - b.status));
        const totalCardsCount = finalSortedArray.length;

        const renderPreETaskCard = (item, pathUrl, label) => {
            const isCompleted = (label === 'Pre-Job' ? isPreJobTasksCompleted : isCIPSecCompleted);
            return <div style={preETaskListItemStyle}>
                <div style={isCompleted ? completedStyle : incompletedStyle}>{item.stationName}</div>
                <div style={completionStyle}> {label} Tasks Complete
                    {item.status<100 ? <ProgressBar percentage={Number.parseInt(item.status)} /> : <ProgressBar percentage={item.status} color={'success'}/>}
                </div>
                <div style={viewTaskStyle}>
                    <Link
                        to={{
                            pathname: pathUrl,
                            project: project
                        }}
                        style={{ fontize: "30px" }}
                    >
                        View Tasks
                    </Link>
                </div>
            </div>
        }

        const renderPreJobAndCIP = (item) => {
            const preEJobTaskPathUrl = `/${status}/${projectId}/projecttasks/Pre-Job`;
            const preEJobCardLabel = 'Pre-Job';
            const cipSecTaskPathUrl = `/${status}/${projectId}/projecttasks/CIP Security`;
            const cipSecCardLabel = 'CIP Security';
            return <>
                {(item.showPreJobTasks) && renderPreETaskCard(item, preEJobTaskPathUrl, preEJobCardLabel)}
                {(item.showCIPSecurityTasks === 1) && renderPreETaskCard(item, cipSecTaskPathUrl, cipSecCardLabel)}
            </>
        }

        const renderIpsLocationsAlone = (item, index) => {
            return <div key={index} style={preETaskListItemStyle}>
                <div style={(item.status === 100) ? completedStyle : incompletedStyle}>{item.name}</div>
                <div style={completionStyle}> Pre Energization Tasks Complete
                    {item.status<100 ? <ProgressBar percentage={Number.parseInt(item.status)} /> : <ProgressBar percentage={item.status} color={'success'}/>}
                </div>
                <div style={viewTaskStyle}>
                    <Link
                        to={{
                            pathname: `/${status}/${projectId}/assettasks/ipslocations/${item.id}`,
                            ipsLocation: item
                        }}
                        style={{ fontize: "30px" }}
                    >
                        View Tasks
                    </Link>
                </div>
            </div>
        }

        const renderConductorCard = (item, index) => {
            return <div key={index} style={preETaskListItemStyle}>
                <div style={(item.status === 100) ? completedStyle : incompletedStyle}>{item.name}</div>
                <div style={completionStyle}>Assets Verified
                    {item.status<100 ? <ProgressBar percentage={Number.parseInt(item.status)} /> : <ProgressBar percentage={item.status} color={'success'}/>}
                </div>
                <div style={viewTaskStyle}>
                    <Link
                        to={{
                            pathname: `/${status}/${projectId}/assetsummary`,
                            state: {
                                applyFilters: true,
                                assetGroupName: 'GeneralConductor',
                                formName: form ? form.formName : null
                            }
                        }}
                        style={{ fontize: "30px" }}
                    >
                        View Assets
                    </Link>
                </div>
            </div>
        }

        const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
            const { carouselState: { currentSlide } } = rest;
            return (
                <div className="carousel-button-group">
                    {/* is starting slide */}
                    {(currentSlide === 0) ?
                        <LeftOutlined
                            className={'disableLeftArrow'} />
                        :
                        <DoubleLeftOutlined
                            className={'leftArrow'}
                            onClick={() => previous()} />
                    }
                    {/* is last slide */}
                    {/*
                   added logic when there is less than 4 card to show disable arrow 
                */}
                    {(currentSlide === (totalCardsCount - 4)) || (totalCardsCount <= 4) ?
                        <RightOutlined
                            className={'disableRightArrow'} />
                        :
                        <DoubleRightOutlined
                            className={'rightArrow'}
                            onClick={() => next()} />
                    }
                </div>
            );
        };

        const responsive = {
            superLargeDesktop: {
                breakpoint: { max: 4000, min: 3000 },
                items: 4
            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 4
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 2
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1
            }
        };

        return (
            <div style={PreETaskListScrollArea}>
                <Carousel
                    arrows={false}
                    customButtonGroup={<ButtonGroup />}
                    renderButtonGroupOutside={true}
                    renderArrowsWhenDisabled={true}
                    responsive={responsive}
                    ssr={true}
                    infinite={false}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    deviceType={this.props.deviceType}>
                    {finalSortedArray && finalSortedArray.map((item, index) =>
                    (<>
                        {
                            (item.stationName) ? renderPreJobAndCIP(item, index) :
                            (item.isConductorCard) ? renderConductorCard(item, index) :
                            renderIpsLocationsAlone(item, index)
                        }
                    </>)
                    )}
                </Carousel>
            </div>
        )
    }
}

export default PreETaskListItem;